import { GlobalComponentsWrapper } from "./GlobalComponentsWrapper";

export { GlobalComponentsWrapper };
